module.exports = __webpack_public_path__ + "img/mariage-2-lazy.0e16fff9.jpg";